import React, { Suspense, lazy } from 'react';
import { useSearchParams } from 'react-router-dom';
import PracticeTally from './PracticeTally.jsx';
import TrainingStatsTable from './TrainingStatsTable.js';
import CoachPracticeAnalytics from './CoachPracticeAnalytics.jsx';
import './PerformanceHub.css';

// Team overview pulls in Observable Plot — lazy-load so the chart weight only
// downloads when a coach opens the Performance hub's Team tab.
const TeamPerformanceOverview = lazy(() => import('./profile/TeamPerformanceOverview.jsx'));

// One "Performance" hub (under Development) that merged the old Performance/Stats
// page with the Operations "Practice Analytics" screen. Flattens Stats' own
// Tally/History tabs up so everything lives in a single tab row.
const TABS = [
  { key: 'team', label: 'Team', icon: '🏆' },
  { key: 'tally', label: 'Practice Tally', icon: '🔢' },
  { key: 'history', label: 'History', icon: '📈' },
  { key: 'analytics', label: 'Practice Analytics', icon: '📊' },
];

function PerformanceHub({ initialTab = 'team' }) {
  const [params, setParams] = useSearchParams();
  const requested = params.get('tab') || initialTab;
  const active = TABS.some(t => t.key === requested) ? requested : 'team';

  const setTab = (key) => setParams(key === 'team' ? {} : { tab: key }, { replace: true });

  return (
    <div className="ph-wrap">
      <div className="ph-head">
        <h1>📊 Performance</h1>
      </div>

      <div className="ph-tabs" role="tablist">
        {TABS.map(t => (
          <button
            key={t.key}
            role="tab"
            aria-selected={active === t.key}
            className={`ph-tab ${active === t.key ? 'active' : ''}`}
            onClick={() => setTab(t.key)}
          >
            <span className="ph-tab-ico">{t.icon}</span>
            {t.label}
          </button>
        ))}
      </div>

      <div className="ph-panel">
        {active === 'team' && (
          <Suspense fallback={<div style={{ padding: '2rem', color: '#9ca3af' }}>Loading charts…</div>}>
            <TeamPerformanceOverview />
          </Suspense>
        )}
        {active === 'tally' && <PracticeTally />}
        {active === 'history' && <TrainingStatsTable />}
        {active === 'analytics' && <CoachPracticeAnalytics embedded />}
      </div>
    </div>
  );
}

export default PerformanceHub;
